import type { ProjectViewerRole } from "@shared/types";

// True for callers who can change project settings, manage members, issue API
// keys, or delete the project. Owners are the project's own admins; a verified
// Cloudflare Access platform admin can act on any project.
export function canManageProject(
  viewerRole: ProjectViewerRole | null | undefined,
): boolean {
  return viewerRole === "owner" || viewerRole === "platform_admin";
}
